import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { EnvService } from './env.service';

@Injectable({ providedIn: 'root' })
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(private env: EnvService) {}

    // Matches a literal "undefined"/"null" as a path segment (/undefined/, /undefined?, trailing /undefined)
    // or as a query value (=undefined&, =undefined end). These almost always mean a route param that used
    // to be inherited from a UI-Router parent state wasn't passed through an Angular Router navigate() call
    // - the FOF-5501 migration param-loss class - and will 400/500 on the backend.
    private static readonly UNDEFINED_PARAM_PATTERN = /\/(undefined|null)(?=[/?]|$)|=(undefined|null)(?=[&#]|$)/;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Dev/test-only tripwire: surface param-loss immediately (in the console of whoever hits the flow)
        // instead of waiting for a Sad Cloud report. Gated off in production so we never log there.
        if (!this.env.ENABLE_PROD_MODE && HttpConfigInterceptor.UNDEFINED_PARAM_PATTERN.test(req.url)) {
            console.error(
                `[param-loss] Outbound request contains "undefined"/"null" - likely a route param not passed ` +
                `through a navigate() call (see QUERY_PARAM_SERIALIZATION_REGRESSIONS.md):\n  ${req.method} ${req.url}`
            );
        }

        let authReq = req;

        // Prevent caching for AJAX requests because this is a problem for IE
        let headers = req.headers.set('Cache-Control', 'no-cache, no-store').set('Pragma', 'no-cache').set('Expires', '0');

        if (
            req.url.includes(this.env.EDGE_SERVICE_PATH) ||
            req.url.includes(this.env.LOGIN_SERVICE_PATH) ||
            req.url.includes(this.env.LOGIN_CONFIGURATION_PATH) ||
            req.url.includes(this.env.PAGE_CONFIGURATION_PATH)
        ) {
            headers = headers.set('Plm-CorrelationId', uuidv4());

            if (!headers.has('Plm-SourceApplication')) {
                headers = headers.set('Plm-SourceApplication', 'sirconIndustryPlatform');
            }
        }

        authReq = req.clone({ headers, withCredentials: true });

        return next.handle(authReq);
    }
}
